import type { CheckboxGroupProps } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { CheckboxGroup } from '@archipro-design/aria';
import type { FilterStatesKey } from '../../type/filter-state';

export interface CheckboxGroupFilter {
    kind: 'CheckboxGroup';
    filterKey: FilterStatesKey;
    subFilterKey?: string;
    props: CheckboxGroupProps;
}

export type CheckboxGroupFilterState = Pick<
    CheckboxGroupProps,
    'items' | 'checkedItems'
> &
    Pick<CheckboxGroupFilter, 'kind'>;

interface FilterCheckboxGroupProps {
    filter: CheckboxGroupFilter;
    state: CheckboxGroupFilterState;
    updateFilter: (
        filterKey: FilterStatesKey,
        state: Partial<CheckboxGroupFilterState>
    ) => void;
    disabled?: boolean;
}

const FilterCheckboxGroup = ({
    filter,
    state,
    updateFilter,
    disabled,
}: FilterCheckboxGroupProps) => {
    const { props, filterKey } = filter;
    return (
        <CheckboxGroup
            {...props}
            {...state}
            checkedItems={state.checkedItems ?? null}
            disabled={disabled}
            onCheckedItemsChange={(_, data) => {
                updateFilter(filterKey, {
                    kind: 'CheckboxGroup',
                    checkedItems: data?.checkedItems ?? [],
                });
            }}
            variables={{
                ...props.variables,
                optionGap: pxToRem(3),
            }}
        />
    );
};

export default FilterCheckboxGroup;
